import { cx } from '@emotion/css';
import { useTranslate } from '@tolgee/react';
import { fromInfo } from './styles';
import { RightOutlined } from '@ant-design/icons';
import { useMemo } from 'react';
import { eventBus } from 'services/eventBus';

interface QAPairButtonProps {
  visible: boolean;
  source: SupplementKnowledge.Source;
  submitted: boolean;
  onClick: (source: SupplementKnowledge.Source, submitted: boolean) => void;
}

export const QAPairButtonUI = (props: { hidden: boolean; text: string; onClick: () => void }) => {
  const { hidden, text, onClick } = props;
  return (
    <div
      className={cx(fromInfo, 'flex items-center gap-1 cursor-pointer', {
        invisible: hidden,
      })}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
    >
      {text}
      <RightOutlined />
    </div>
  );
};

export const QAPairButton = (props: QAPairButtonProps) => {
  const { visible, source, submitted, onClick } = props;
  const { t } = useTranslate();

  const text = useMemo(() => {
    if (source === 'AI_ERROR_REPLY') {
      return submitted
        ? t('scene.chatWorkspace.messageScenario.feedback.productKnowledgeSubmitted')
        : t('scene.chatWorkspace.messageScenario.action.submitAnswer');
    }
    return submitted
      ? t('scene.chatWorkspace.messageScenario.feedback.productKnowledgeSubmitted')
      : t('scene.chatWorkspace.messageScenario.action.submitAnswer');
  }, [source, submitted, t]);

  return (
    <QAPairButtonUI
      hidden={visible}
      text={text}
      onClick={() => {
        eventBus.emit('CLEAR_QAPAIR_COUNTDOWN_TIMER');
        onClick(source, submitted);
      }}
    />
  );
};
